export default function ApiNodata({message}){
    return <>
        <div className="p-2 text-center">
            <p className="text-secondary fw-bold">{message} <br />
            <img src="/myicons/no-data.png" alt={`loading`} className="img-fluid" width="100" height="100" />
            </p>
        </div>
    </>;
}